<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab :title="$t('students.master_students')" active>
              <data-table ></data-table>
            </b-tab>
            <!-- <b-tab @click="newItem = {}" :title="$t('site.add')">
              <my-form :newItem="newItem"></my-form>
            </b-tab> -->
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import DataTableVue from "./components/DataTable.vue";
import FormVue from "./components/Form.vue";

export default {
  name: "UsersIndex",
  components: {
    "data-table": DataTableVue,
    "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tab: 0,
      title: "",
    };
  },
  created() {

  },
  methods: {
    // editItem(data) {
    //   delete data.item.cv;
    //   delete data.item.profile_image;
    //   this.newItem = data.item;

    //   this.tab = 1;
    // },
  },
  
};
</script>

